import {useDelay, useTitle} from 'hooks';
import {useParams, useSearchParams} from 'react-router-dom';
import {Spinner, Transitioner} from 'components';

import PaymentCardsMine from './components/PaymentCards.Mine';

interface IPagePaymentCardsProps {}

const PagePaymentCards = ({}: IPagePaymentCardsProps) => {
  useTitle('Payment Cards');

  const params = useParams();
  const workspace = params.workspace ?? '';
  const resource = params.resource ?? '';

  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === 'true';

  const {isDelaying} = useDelay(success ? 2 * 1000 : 0);
  if (isDelaying) {
    return (
      <Transitioner key="spinner">
        <div className="flex justify-center items-center py-10 sm:py-24">
          <Spinner />
        </div>
      </Transitioner>
    );
  }

  if (workspace === 'me') {
    return <PaymentCardsMine />;
  }

  return (
    <Transitioner key={`/${workspace}/${resource}`}>
      <h1>Payment Cards</h1>
    </Transitioner>
  );
};

export default PagePaymentCards;
